import React, { lazy } from "react";
import SearchBox from "../SearchBox/SearchBox";
import EntityRow from "../EntityRow/EntityRow";
import JobRow from "../../../features/jobs/JobRow";
import Pagination from "../Pagination/Pagination";
import "./EntityList.css";

const EntityList = ({
    items = [],
    title = "Items",
    searchPlaceholder = "Search...",
    entityType,
    itemsPerPage = 6,
    itemName = "users",
    onToggle = () => { },
    onAdd = () => { },
    onEdit = () => { },
    onClone = () => { },
    onDelete = () => { },
    onStart = () => { },
    onStop = () => { },
    onDownloadReport = () => { },
    expandedJobId = null,
    onExpandToggle = () => { },
    onRefreshRun = () => { },
    // Server-side pagination props
    currentPage = 1,
    totalItems = 0,
    onPageChange = () => { },
    // Server-side search props
    searchQuery = "",
    onSearchChange = () => { },
    setIsLoading,
}) => {
    // Dynamically import JobRow only when needed
    const RowComponent =
        entityType === "jobs" ? JobRow : EntityRow;

    return (
        <>
            <div className="connections-list">
                <div className="connections-header">
                    <h2 className="connections-title">{title}</h2>
                    <SearchBox
                        value={searchQuery}
                        onChange={onSearchChange}
                        placeholder={searchPlaceholder}
                        width="16.667vw"  /* 320px */
                        iconSize="0.833vw"  /* 16px */
                    />
                </div>

                <div className="connections-rows">
                    {items.length > 0 ? (
                        items.map((item) => (
                            <RowComponent
                                key={item.id}
                                item={item}
                                onToggle={onToggle}
                                onEdit={onEdit}
                                onClone={onClone}
                                onDelete={onDelete}
                                onStart={onStart}
                                onStop={onStop}
                                onDownloadReport={onDownloadReport}
                                isExpanded={expandedJobId === item.id}
                                onExpandToggle={onExpandToggle}
                                onRefreshRun={onRefreshRun}
                                setIsLoading={setIsLoading}
                            />
                        ))
                    ) : (
                        <div className="no-results">
                            <p>
                                No {title.toLowerCase()} found
                                {searchQuery ? ` for "${searchQuery}"` : ""}
                            </p>
                        </div>
                    )}
                </div>

                {totalItems > 0 && (
                    <Pagination
                        currentPage={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        onPageChange={onPageChange}
                        itemName={itemName}
                    />
                )}

            </div>

        </>
    );
};

export default EntityList;